<script setup lang="ts">
import { computed, Component } from "vue";
import store from "@/store";

import { DesktopEvaluationTheme, MobileEvaluationTheme } from ".";

import type {
  EvaluationType,
  EvaluationListType,
} from "@/common/types/evaluation";

interface TabListType {
  [key: string]: {
    key: string;
    icon: string;
    label: string;
    component: Component;
  };
}

const emit = defineEmits(["update-data", "add", "input-search", "search"]);

const props = defineProps<{
  accountId: string;
  evaluationId: string;
  evaluation: EvaluationType | null;
  evaluations: EvaluationListType[];
  tabList: TabListType;
  menuList: any;
  isEdit: boolean;
}>();

const listMenu = computed(() =>
  props.menuList.reduce((acc, item) => {
    const modules = store.getters.modules;

    if (modules.find((mod) => mod.code === `${item.key.toUpperCase()}_NOT`)) {
      return acc;
    } else {
      acc.push(item);
    }

    return acc;
  }, []),
);
</script>

<template>
  <template v-if="!$store.getters.mobile">
    <desktop-evaluation-theme
      :is-edit="isEdit"
      :account-id="accountId"
      :evaluation-id="evaluation?.evaluation_id || null"
      :evaluation="evaluation"
      :evaluations="evaluations"
      :tab-list="tabList"
      :menu-list="listMenu"
      @update-data="emit('update-data')"
      @add="emit('add')"
      @input-search="emit('input-search', $event)"
      @search="emit('search', $event)"
    />
  </template>

  <template v-else>
    <mobile-evaluation-theme
      :is-edit="isEdit"
      :account-id="accountId"
      :evaluation-id="evaluation?.evaluation_id || null"
      :evaluation="evaluation"
      :evaluations="evaluations"
      :tab-list="tabList"
      :menu-list="menuList"
      @update-data="emit('update-data')"
      @add="emit('add')"
      @input-search="emit('input-search', $event)"
      @search="emit('search', $event)"
    />
  </template>
</template>
